export const getProcedureUrl = (objectEntry) => {
  return `${window.location.origin}/sites/${objectEntry?.site?.identifier}/subjects/${objectEntry?.subject?.number}/study_events/${objectEntry?.studyEvent?.identifier}/study_procedures/${objectEntry?.identifier}`;
};

export const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

export default getProcedureUrl;
